import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyledEmptyBox } from './styles';

export default function EmptyState() {
  const { t } = useTranslation('widgets');
  return (
    <StyledEmptyBox>
      <Typography variant="body2" color="textSecondary">
        {t('notifications.no-notifications')}
      </Typography>
    </StyledEmptyBox>
  );
}
